// extracted by mini-css-extract-plugin
export default {"list":"magical-insight_list__8x5ZR"};